import { FPagePreciseNameEnum } from '@/types/pages';
import { FTunnelPageBookingTypeEnum, FTunnelPageStepEnum } from '@/types/tunnel';
import buildExperienceHref from '@/utils/routes/buildExperienceHref';
import buildTunnelHref from '@/utils/routes/buildTunnelHref';
import { isProd } from '@winelidays/wld-tsx-2/utils';
import { COMMON_QUERY_PARAMS } from './debug';
/**
 * Env vars
 */
export const ENV = process.env.APP_ENV ?? 'production';
export const IS_PROD = isProd(ENV);
export const APP_VERSION = [undefined, null, 'REPLACE_ME'].includes(process.env.APP_VERSION) ?
    'undefined' :
    process.env.APP_VERSION;
export const TAG_MANAGER_PROJECT = process.env.TAG_MANAGER_PROJECT;
if (!TAG_MANAGER_PROJECT) {
    throw new Error('Missing TAG_MANAGER_PROJECT');
}
export const INITIAL_APP_URL = window.location.href;
const referrerScript = document.getElementById('referrer');
export const INITIAL_REFERRER = referrerScript?.textContent ?
    referrerScript.textContent :
    document.referrer;
/**
 * Retrieve Partner config
 */
const configScript = document.getElementById('config');
const CONFIG = configScript?.textContent ? JSON.parse(configScript.textContent) : {};
export const { establishmentId: ESTABLISHMENT_ID, establishmentName: ESTABLISHMENT_NAME, establishmentEmail: ESTABLISHMENT_EMAIL, establishmentPhone: ESTABLISHMENT_PHONE, establishmentCity: ESTABLISHMENT_CITY, establishmentRegionId: ESTABLISHMENT_REGION_ID, establishmentSousRegionId: ESTABLISHMENT_SOUS_REGION_ID, locale: LOCALE, iframeLocale: IFRAME_LOCALE, token: TOKEN, withReviews: WITH_REVIEWS } = CONFIG;
/**
 * Retrieve languages
 */
const languagesScript = document.getElementById('languages');
export const LANGUAGES = languagesScript?.textContent ?
    JSON.parse(languagesScript.textContent) :
    [];
/**
 * Retrieve modal
 */
const modalScript = document.getElementById('modal');
export const IS_MODAL = modalScript?.textContent ?
    modalScript.textContent === 'true' :
    false;
/**
 * Retrieve experienceId
 */
const experienceIdScript = document.getElementById('experienceId');
export const EXPERIENCE_ID = experienceIdScript?.textContent ?
    parseInt(experienceIdScript.textContent) :
    null;
/**
 * Retrieve bookingExperienceId
 */
const bookingExperienceIdScript = document.getElementById('bookingExperienceId');
export const BOOKING_EXPERIENCE_ID = bookingExperienceIdScript?.textContent ?
    parseInt(bookingExperienceIdScript.textContent) :
    null;
/**
 * Retrieve bookingVoucherExperienceId
 */
const bookingVoucherExperienceIdScript = document.getElementById('bookingVoucherExperienceId');
export const BOOKING_VOUCHER_EXPERIENCE_ID = bookingVoucherExperienceIdScript?.textContent ?
    parseInt(bookingVoucherExperienceIdScript.textContent) :
    null;
/**
 * Retrieve confirmExperienceId
 */
const confirmExperienceIdScript = document.getElementById('confirmExperienceId');
export const CONFIRM_EXPERIENCE_ID = confirmExperienceIdScript?.textContent ?
    parseInt(confirmExperienceIdScript.textContent) :
    null;
/**
 * Retrieve confirmVoucherExperienceId
 */
const confirmVoucherExperienceIdScript = document.getElementById('confirmVoucherExperienceId');
export const CONFIRM_VOUCHER_EXPERIENCE_ID = confirmVoucherExperienceIdScript?.textContent ?
    parseInt(confirmVoucherExperienceIdScript.textContent) :
    null;
/**
 * HOME
 */
export const DEFAULT_HOME_PATH = `/${COMMON_QUERY_PARAMS}`;
export const HOME_PATH = CONFIRM_VOUCHER_EXPERIENCE_ID ?
    buildTunnelHref(FTunnelPageBookingTypeEnum.voucher, CONFIRM_VOUCHER_EXPERIENCE_ID, FTunnelPageStepEnum.confirmation) :
    CONFIRM_EXPERIENCE_ID ?
        buildTunnelHref(FTunnelPageBookingTypeEnum.standard, CONFIRM_EXPERIENCE_ID, FTunnelPageStepEnum.confirmation) :
        BOOKING_VOUCHER_EXPERIENCE_ID ?
            buildTunnelHref(FTunnelPageBookingTypeEnum.voucher, BOOKING_VOUCHER_EXPERIENCE_ID) :
            BOOKING_EXPERIENCE_ID ?
                buildTunnelHref(FTunnelPageBookingTypeEnum.standard, BOOKING_EXPERIENCE_ID) :
                EXPERIENCE_ID ?
                    buildExperienceHref(EXPERIENCE_ID) :
                    DEFAULT_HOME_PATH;
export const HOME_PATH_NAME = BOOKING_VOUCHER_EXPERIENCE_ID ?
    FPagePreciseNameEnum.voucherTunnel :
    BOOKING_EXPERIENCE_ID ?
        FPagePreciseNameEnum.bookingTunnel :
        EXPERIENCE_ID ?
            FPagePreciseNameEnum.experiencePage :
            FPagePreciseNameEnum.experienceList;
export const COMPUTED_EXPERIENCE_ID = CONFIRM_VOUCHER_EXPERIENCE_ID ??
    CONFIRM_EXPERIENCE_ID ??
    BOOKING_VOUCHER_EXPERIENCE_ID ??
    BOOKING_EXPERIENCE_ID ??
    EXPERIENCE_ID ??
    null;
/**
 * Redirect url
 */
const redirectUrlScript = document.getElementById('redirectUrl');
export const REDIRECT_URL = redirectUrlScript?.textContent ?
    redirectUrlScript.textContent :
    null;
/**
 * Hide image
 */
const HIDE_IMAGE_IN_BOOKING_SUMMARY_ESTABLISHMENT_IDS = process.env.HIDE_IMAGE_IN_BOOKING_SUMMARY_ESTABLISHMENT_IDS ?? '';
const HIDE_IMAGE_IN_BOOKING_SUMMARY_ESTABLISHMENT_IDS_ARRAY = HIDE_IMAGE_IN_BOOKING_SUMMARY_ESTABLISHMENT_IDS != '' ?
    HIDE_IMAGE_IN_BOOKING_SUMMARY_ESTABLISHMENT_IDS.split(',').
        map((str) => parseInt(str)).
        filter((id) => !isNaN(id)) :
    [];
export const HIDE_IMAGE_IN_BOOKING_SUMMARY = HIDE_IMAGE_IN_BOOKING_SUMMARY_ESTABLISHMENT_IDS_ARRAY.reduce((acc, id) => {
    return acc || ESTABLISHMENT_ID === id;
}, false);
